// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import { useEffect } from 'react';

/**
 * Custom hook to handle ESC key press
 * @param {Function} onEscape - Callback function to execute when ESC is pressed
 * @param {boolean} enabled - Whether the hook is active (default: true)
 */
export const useEscapeKey = (onEscape, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscape();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape, enabled]);
};

export default useEscapeKey;
